/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description My stage card
 */

// Dependencies
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Helpers
import { STAGE_INDICATOR } from '@nephro/pages/Indicators/helpers/constants';
import { getPatientStage } from '@nephro/pages/Indicators/helpers/utils';

// Hooks
import usePatientIndicators from '@nephro/pages/Indicators/helpers/usePatientIndicators';

// Assets
import { ReactComponent as KidneyIcon } from '@nephro/assets/kidney_white.svg';

// Components
import { sortByDate } from 'commons/helpers/utils';
import { getAlbumiCreati } from 'pages/Indicators/helpers/utils';
import DashboardPatientCard from '../dashboardPatientCard';

const MyStageCard = () => {
  const { t: translate } = useTranslation();
  const stageIndicator = usePatientIndicators(STAGE_INDICATOR);
  const [data, setData] = useState(null);

  const title = translate('dashboardPatient.stageTitle');

  // Stages Array Data
  const stagesMenuArray = [
    {
      stage: '1',
      albuminuria: 'A1'
    },
    {
      stage: '2',
      albuminuria: 'A1'
    },
    {
      stage: '3a',
      albuminuria: 'A2'
    },
    {
      stage: '3b',
      albuminuria: 'A2'
    },
    {
      stage: '4',
      albuminuria: 'A3'
    },
    {
      stage: '5',
      albuminuria: 'A3'
    }
  ];

  useEffect(() => {
    if (stageIndicator.length > 0) {
      const [stageItem] = stageIndicator?.filter(
        (itm) => itm.indicador_id === 1 && itm.parametro === 2
      );

      const albCrt = stageIndicator?.filter(
        (itm) => itm.indicador_id === 1 && itm.parametro !== 2
      );
      let albuminuria = '';
      const patientStage = getPatientStage(stageItem.valor);
      if (albCrt.length > 0) {
        const [recentDateItem] = sortByDate(albCrt, 'fecha');
        albuminuria = getAlbumiCreati(recentDateItem.valor);
      }
      const [itemStage] = stagesMenuArray.filter(
        (itm) => patientStage === itm.stage
      );
      const footer = {
        text: `${itemStage?.stage}${
          albuminuria?.text ? `/${albuminuria?.text}` : ''
        }`
      };
      const componentData = {
        title,
        link: 'stages',
        mainIcon: <KidneyIcon />,
        footer,
        background: 'bg-cardCyan',
        textStyles: 'text-green-900',
        titleStyles: 'text-green-900'
      };
      setData(componentData);
    }
  }, [title, stageIndicator]);

  return <DashboardPatientCard data={data} />;
};

export default MyStageCard;
